// cart
function replaceOptionLabels() {
  const optionLabels = document.querySelectorAll('.cart-items .product-option');
  optionLabels.forEach((block) => {
    const dt = block.querySelector('dt');
    const dd = block.querySelector('dd');

    if (!dt || !dd) return;
    const label = dt.textContent.trim();
    const value = dd.textContent.trim();

    if (label === 'Color:') {
      dt.textContent = 'カラー：';
    } else if (label === 'Size:') {
      dt.textContent = 'サイズ：';
    } else if (label === 'Condition:') {
      dt.textContent = 'コンディション：';
    }

    if (label === 'Condition:' && value === 'S') {
      dd.textContent = 'S: 新品同様';
    } else if (label === 'Condition:' && value === 'A') {
      dd.textContent = 'A: 未使用に近い';
    } else if (label === 'Condition:' && value === 'B') {
      dd.textContent = 'B: 目立つ使用感なし';
    } else if (label === 'Condition:' && value === 'C') {
      dd.textContent = 'C: やや使用感あり';
    } else if (label === 'Condition:' && value === 'D') {
      dd.textContent = 'D: 使用感あり';
    }

  });
}
document.addEventListener('DOMContentLoaded', function () {
  replaceOptionLabels();
  // カートページのフォームは <form id="cart" class="cart__contents">（main-cart-items.liquid）。
  // cart.js は数量変更・削除のたびに内側の .js-contents を差し替えるが、form 自体は残るのでここを監視する
  const target = document.getElementById('cart');
  if (target) {
    const observer = new MutationObserver(() => {
      replaceOptionLabels();
    });
    observer.observe(target, { childList: true, subtree: true });
  }
});
